<template>
  <div class="login-page theme-audra">
    <div class="container-fluid">
      <div class="row align-items-center">
        <div class="col-md-8">
          <div class="card login-box position-relative">
            <div class="overlay text-center" v-if="is_loading">
              <img src="/assets/images/loader.svg" alt="" />
            </div>
            <div>
              <img :src="getImage('logo.svg')" alt="Dotlines" />

              <form
                @submit.prevent="login()"
                method="POST"
                class="response-alert"
                novalidate
              >
                <div class="form-group mb-3">
                  <label class="control-label"> {{ $t("username") }}</label>
                  <input
                    type="text"
                    name="user_name"
                    v-model.trim="user.username"
                    class="form-control"
                    placeholder="Username"
                    v-validate="'required'"
                    :class="{ 'has-error': errors.has('user_name') }"
                  />
                  <div class="help text-danger" v-show="errors.has('user_name')">
                    {{ errors.first("user_name") }}
                  </div>
                </div>

                <div class="form-group mb-3">
                  <label class="control-label">{{ $t("password") }}</label>
                  <div class="password">
                    <input
                      type="password"
                      name="password"
                      v-model.trim="user.password"
                      class="form-control"
                      placeholder="Password"
                      v-validate="'required'"
                      :class="{ 'has-error': errors.has('password') }"
                      :type="showPassword ? 'text' : 'password'"
                    />
                    <span class="password-toggle" @click="togglePassword">
                      <i
                        :class="{
                          'icon-eye-off': showPassword,
                          'icon-eye': !showPassword,
                        }"
                      ></i>
                    </span>
                  </div>

                  <div class="help text-danger" v-show="errors.has('password')">
                    {{ errors.first("password") }}
                  </div>
                </div>
                <div class="row mb-3 align-items-center">
                  <div class="col-6">
                    <div class="icheck-primary">
                      <input type="checkbox" v-model.trim="user.remember" id="remember" />
                      <label for="remember"> {{ $t("remember_me") }} </label>
                    </div>
                  </div>
                  <!-- /.col -->
                  <div class="col-6 text-right forgot-pass">
                    <router-link :to="{ name: 'ForgotPassV3' }">
                      {{ $t("forgot_password") }}
                    </router-link>
                  </div>
                </div>
                <button
                  type="submit"
                  class="btn btn-common btn-block fw-500"
                  :disabled="is_disabled"
                >
                  Login
                </button>
              </form>
            </div>
          </div>
        </div>
        <div class="col-md-4 ml-auto d-none d-sm-block">
          <div class="login-img">
            <h2><span>Satisfyingly</span> simple <strong>Security</strong>.</h2>
            <img class="like" src="/assets/images/like.png" alt="like" />
            <img class="sheild" src="/assets/images/sheild.png" alt="sheild" />
            <img class="wifi" src="/assets/images/wifi.png" alt="wifi" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GuestLayout from "@/components/layouts/GuestLayoutComponent.vue";
import LocalStorage from "@/services/localStorage";
import axios from "axios";
import { mapActions } from "vuex";
import Swal from "sweetalert2";

export default {
  metaInfo: {
    title: "Login | Dotlines",
  },
  data: () => ({
    user: {},
    is_loading: false,
    is_disabled: false,
    showPassword: false,
  }),
  methods: {
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    ...mapActions(["LOGIN", "LOGOUT", "LOGIN_AUDRA_DEVICE_FIRSTTIME"]),

    login: function (e) {
      const _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.startLoading();
          _this.storeUserCredentials();
          _this
            .LOGIN_AUDRA_DEVICE_FIRSTTIME(_this.user)
            .then((response) => _this.handleLoginSuccess(response))
            .catch((error) => _this.handleLoginError(error))
            .finally(() => _this.stopLoading());
        }
      });
    },

    storeUserCredentials: function () {
      LocalStorage.set("userEmail", this.user.username);
      LocalStorage.set("userPassword", this.user.password);
      LocalStorage.set("rememberUser", this.user.remember ? 1 : 0);
    },

    handleLoginSuccess: function (response) {
      if (response === "otp_page") {
        this.$router.push({ name: "TwoFactor" });
      } else {
        axios.defaults.baseURL = LocalStorage.get("baseAPIURL") + "/api";
        this.$router.push({ name: "Home" });
      }
    },

    handleLoginError: function (error) {
      let errorMessage = "Invalid username or password!";

      if (error.data) {
        if (error.data.error_description === "User is not active") {
          this.displayError(error.data.error_description, 500);
          this.$router.push({ name: "ForgotPassV3" });
          return;
        }

        if (error.data.error_description === "Device is inactive") {
          Swal.fire({
            title: "Router Inactive",
            text:
              "To activate your router, please download the Audra App from playstore...",
            icon: "warning",
            confirmButtonText: "OK",
          }).then((result) => {
            if (result.isConfirmed) {
            }
          });
        }
        let isCalled = 0;
        if (error.status === 429) {
          const errorData = error.data;
          if (errorData.message && errorData.retry_after_minutes) {
            errorMessage = `${errorData.message}`;
            isCalled = 1;
            this.displayError(errorMessage, 5000);
          }
        }

        if (!isCalled) this.displayError(errorMessage, 5000);
      }
    },
    displayError: function (message, timeout) {
      $(".response-alert").prepend(
        $(
          '<div class="alert alert-danger alert-dismissible fade show" role="alert">\n' +
            `    ${message}\n` +
            '    <button type="button" class="close" data-dismiss="alert" aria-label="Close">\n' +
            '       <span aria-hidden="true">&times;</span>\n' +
            "    </button>\n" +
            "</div>"
        )
      );

      setTimeout(() => {
        $(".alert").fadeOut("slow");
      }, timeout);
    },

    startLoading: function () {
      this.is_loading = true;
      this.is_disabled = true;
    },

    stopLoading: function () {
      this.is_loading = false;
      this.is_disabled = false;
    },
  },
  mounted: function () {
    this.LOGOUT();
    this.user.username = LocalStorage.get("userEmail") || "";
    this.user.password = LocalStorage.get("userPassword") || "";
    this.user.remember = LocalStorage.get("rememberUser") == 1 ? true : false;

    if (!this.user.remember) {
      this.user.username = "";
      this.user.password = "";
    }
    localStorage.setItem("authenticate", false);
  },
  created() {
    this.$emit("update:layout", GuestLayout);
  },
};
</script>
